import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "dialog-footer" }

import { ref, reactive } from "vue";
import type { FormInstance } from "element-plus";
import { websiteTenant } from "@/core/types/TenantTypes";
import SystemService from "../../../system/services/SystemService";

export default /*#__PURE__*/_defineComponent({
  __name: 'EditPromotionKey',
  emits: ["submit"],
  setup(__props, { expose: __expose, emit: emits }) {

const dialogRef = ref(false);
const isSubmitting = ref(false);
const promotionId = ref(0);
const ruleFormRef = ref<FormInstance>();
const formData = reactive({
  key: "",
  access_sites: ["bvi"],
});

const rules = reactive<any>({
  key: [{ required: true, message: "Please input item key", trigger: "blur" }],
  access_sites: [
    {
      required: true,
      message: "Please select access sites",
      trigger: "change",
    },
  ],
});



const submit = async () => {
  if (!ruleFormRef.value) return;

  let isValid = false;
  await ruleFormRef.value.validate(async (valid, fields) => {
    isValid = valid;
  });
  if (!isValid) return;

  isSubmitting.value = true;
  try {
    const res = await SystemService.editPromotionKey(
      promotionId.value,
      formData
    );
    if (res) {
      dialogRef.value = false;
      formData.key = "";
      formData.access_sites = ["bvi"];
      emits("submit");
    }
  } catch (error) {
    console.error(error);
  } finally {
    isSubmitting.value = false;
  }
};

const show = (item) => {
  dialogRef.value = true;
  promotionId.value = item.id;
  formData.key = item.key;
  formData.access_sites = item.access_sites;
};

__expose({
  show,
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogRef.value,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dialogRef).value = $event)),
    title: "Edit Promotion Key",
    width: "500",
    "align-center": ""
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (dialogRef.value = false)),
          disabled: isSubmitting.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.cancel")), 1)
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: submit,
          loading: isSubmitting.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.update")), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "ruleFormRef",
        ref: ruleFormRef,
        model: formData,
        rules: rules,
        "label-position": "top"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.key'),
            prop: "title"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formData.key,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.key) = $event)),
                disabled: isSubmitting.value
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.sites'),
            prop: "access_sites"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_checkbox_group, {
                modelValue: formData.access_sites,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.access_sites) = $event)),
                disabled: isSubmitting.value
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(websiteTenant), (tenant, index) => {
                    return (_openBlock(), _createBlock(_component_el_checkbox, {
                      key: index,
                      label: tenant.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(tenant.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})